export default () => ({
  yAxis: {
    lineWidth: 0,
  },
});
